import { useEffect, useState } from "react";
import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import { AudioWaveform, Blocks, ChevronDown, ChevronLeft, DownloadCloud, Fan, File, Flag, FolderCheck, Grid3X3, Heart, Info, LibraryBig, MessageCircle, Pencil, ShoppingCart, SquareDashedMousePointer, Video } from "lucide-react";

const CourseContentCard =({setShowLeftQueBar,coursePageObject,progress=20})=>{
      const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;

      
  const [toggleState , setToggleState] =useState(false)
  const [theme , setTheme] =useState("")
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    
    </div>
  );
};
    return(<>
    <div className="sidebarCardOuter">
       
 <div className="sidebarCardSection">
    
<div className="sidebarCardSectionInner" style={{background:`${coursePageObject?.milestone?.bgColor?.color}`,
border:` ${coursePageObject?.milestone?.border?.borderWidth?.value+coursePageObject?.milestone?.border?.borderWidth?.resolution} ${coursePageObject?.milestone?.border?.borderType}  ${coursePageObject?.milestone?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.milestone?.borderRadius?.topLeft?.value}${coursePageObject?.milestone?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.milestone?.borderRadius?.topRight?.value}${coursePageObject?.milestone?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.milestone?.borderRadius?.bottomLeft?.value}${coursePageObject?.milestone?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.milestone?.borderRadius?.bottomRight?.value}${coursePageObject?.milestone?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}>
    <div >
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:"5px"}}>
        <Fan size={16} color={coursePageObject?.milestone?.textColor?.color} />
    <div className="coursePageTitleFont"  style={{fontSize:"12px",fontWeight:"800",margin:"0px",width:"65px",color:`${coursePageObject?.milestone?.textColor?.color}`}}>{coursePageObject?.milestone?.title}</div>&bull;
 <div className="coursePageTitleFont playerSidebarEllipsis"  style={{fontSize:"12px",fontWeight:"800",margin:"0px",width:"70px",color:`${coursePageObject?.milestone?.textColor?.color}`}}>Sub Course 1 </div> 
<button  className="coursePage__wishlist" style={{background:`${coursePageObject?.milestone?.iconBgColor?.color}`,border:"0px",width:"40px",padding:"5px 3px"}} onClick={() => {}}>
   <span className='coursePageButtonFont' style={{fontSize:"9px",color:`${coursePageObject?.milestone?.iconColor?.color}`}}> Change</span></button>

    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    
    <span  className="coursePageTagsFont" style={{fontSize:"10px",color:`${coursePageObject?.milestone?.textColor?.color}`}}>3 Sections</span><span  className="coursePageTagsFont" style={{fontSize:"10px",color:`${coursePageObject?.milestone?.textColor?.color}`}}>&bull; 7 Chapters</span>
    </div>    </div>
    <div style={{background:`${coursePageObject?.milestone?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><ChevronDown size={22}  color={coursePageObject?.milestone?.iconColor?.color}/></div> 


</div> 
<div className="sidebarCardSectionInner" style={{background:`${coursePageObject?.section?.bgColor?.color}`,
border:` ${coursePageObject?.section?.border?.borderWidth?.value+coursePageObject?.section?.border?.borderWidth?.resolution} ${coursePageObject?.section?.border?.borderType}  ${coursePageObject?.section?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.section?.borderRadius?.topLeft?.value}${coursePageObject?.section?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.section?.borderRadius?.topRight?.value}${coursePageObject?.section?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.section?.borderRadius?.bottomLeft?.value}${coursePageObject?.section?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.section?.borderRadius?.bottomRight?.value}${coursePageObject?.section?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}>
    <div >
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
        <Blocks size={26} color={coursePageObject?.section?.textColor?.color} />
    <div className="coursePageTitleFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${coursePageObject?.section?.textColor?.color}`}}>{coursePageObject?.section?.title} </div>

    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    
    <span  className="coursePageTagsFont"  style={{fontSize:"10px",color:`${coursePageObject?.section?.textColor?.color}`}}>3 Chapters</span><span  className="coursePageTagsFont" style={{fontSize:"10px",color:`${coursePageObject?.section?.textColor?.color}`}}>&bull; 7 Lectures</span><span  className="coursePageTagsFont"  style={{fontSize:"10px",color:`${coursePageObject?.section?.textColor?.color}`}}>&bull; 9 Quizzes</span><span  className="coursePageTagsFont"  style={{fontSize:"10px",color:`${coursePageObject?.section?.textColor?.color}`}}>  &bull; 3 PDFs</span>
    </div>    </div>
    <div style={{background:`${coursePageObject?.section?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><ChevronDown size={22}  color={coursePageObject?.section?.iconColor?.color}/></div> 


</div>

 <div className="sidebarCardChapter">
    <div className="sidebarCardSectionInner" style={{background:`${coursePageObject?.chapter?.bgColor?.color}`,
border:` ${coursePageObject?.chapter?.border?.borderWidth?.value+coursePageObject?.chapter?.border?.borderWidth?.resolution} ${coursePageObject?.chapter?.border?.borderType}  ${coursePageObject?.chapter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.chapter?.borderRadius?.topLeft?.value}${coursePageObject?.chapter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.chapter?.borderRadius?.topRight?.value}${coursePageObject?.chapter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.chapter?.borderRadius?.bottomLeft?.value}${coursePageObject?.chapter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.chapter?.borderRadius?.bottomRight?.value}${coursePageObject?.chapter?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}><div>
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <AudioWaveform size={26} color={coursePageObject?.chapter?.textColor?.color} />
    <div className="coursePageTitleFont" style={{fontSize:"14px",fontWeight:"800",margin:"0px",color:`${coursePageObject?.chapter?.textColor?.color}`}}>{coursePageObject?.chapter?.title}</div>
    </div><div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    
    <span className="coursePageTagsFont" style={{fontSize:"10px",color:`${coursePageObject?.chapter?.textColor?.color}`}}>2 Lectures</span><span  className="coursePageTagsFont"  style={{fontSize:"10px",color:`${coursePageObject?.chapter?.textColor?.color}`}}>&bull; 3 Quizzes</span><span  className="coursePageTagsFont"  style={{fontSize:"10px",color:`${coursePageObject?.chapter?.textColor?.color}`}}> &bull; 1 PDF</span>
    </div> 
    </div>
    <div style={{background:`${coursePageObject?.chapter?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><ChevronDown size={22}  color={coursePageObject?.chapter?.iconColor?.color}/></div> 


</div>
    <div className="sidebarLessonCardOuter" style={{background:`${coursePageObject?.lessonCard?.bgColor?.color}`,
border:` ${coursePageObject?.lessonCard?.border?.borderWidth?.value+coursePageObject?.lessonCard?.border?.borderWidth?.resolution} ${coursePageObject?.lessonCard?.border?.borderType}  ${coursePageObject?.lessonCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.lessonCard?.borderRadius?.topLeft?.value}${coursePageObject?.lessonCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.lessonCard?.borderRadius?.topRight?.value}${coursePageObject?.lessonCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.lessonCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.lessonCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.lessonCard?.borderRadius?.bottomRight?.value}${coursePageObject?.lessonCard?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}>
<div className="sidebarlessonCard">
  {coursePageObject?.lessonCard?.lessonCardTheme=="T1"?
<div className="sidebarlessonInnerSectionThemeTwo"  >
    <div className="">
    <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={coursePageObject?.lessonCard?.textColor?.color} />
    <div className="coursePageHeaderFont" style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}>{coursePageObject?.lessonCard?.title1}</div>
    </div>
    <div style={{background:`${coursePageObject?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={coursePageObject?.lessonCard?.iconColor?.color}/></div> 


</div> <ImageFallFB  boxShadow={``}
                  src={coursePageObject?.lessonCard?.imageThumbnail?.src}
                  border={coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderType +" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={coursePageObject?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ coursePageObject?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
                 
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
    
   <h3 className="coursePageTitleFont"  style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding</h3>
   <p className="playerSidebarEllipsis coursePageSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding, he loves coding</p>
   </div>
</div>
</div>:coursePageObject?.lessonCard?.lessonCardTheme=="T2"?<div className="sidebarlessonInnerSection" >
    <div className="sidebarlessoImage">
   
  <ImageFallFB  boxShadow={``}
                  src={coursePageObject?.lessonCard?.imageThumbnail?.src}
                  border={coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderType +" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={coursePageObject?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ coursePageObject?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
                
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
     <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={coursePageObject?.lessonCard?.textColor?.color} />
    <div className="coursePageHeaderFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}>{coursePageObject?.lessonCard?.title1}</div>
    </div>
    <div style={{background:`${coursePageObject?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={coursePageObject?.lessonCard?.iconColor?.color}/></div> 


</div>
   <h3 className="coursePageTitleFont " style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding</h3>
   <p className="playerSidebarEllipsis coursePageSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding, he loves coding</p>
   </div>
</div>
</div>:""}

</div>

<div >
     
     
</div>
    </div>




     <div className="sidebarLessonCardOuter" style={{background:`${coursePageObject?.lessonCard?.bgColor?.color}`,
border:` ${coursePageObject?.lessonCard?.border?.borderWidth?.value+coursePageObject?.lessonCard?.border?.borderWidth?.resolution} ${coursePageObject?.lessonCard?.border?.borderType}  ${coursePageObject?.lessonCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.lessonCard?.borderRadius?.topLeft?.value}${coursePageObject?.lessonCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.lessonCard?.borderRadius?.topRight?.value}${coursePageObject?.lessonCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.lessonCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.lessonCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.lessonCard?.borderRadius?.bottomRight?.value}${coursePageObject?.lessonCard?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px"}}>
<div className="sidebarlessonCard">
  {coursePageObject?.lessonCard?.lessonCardTheme=="T1"?
<div className="sidebarlessonInnerSectionThemeTwo"  >
    <div className="">
    <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={coursePageObject?.lessonCard?.textColor?.color} />
    <div className="coursePageHeaderFont" style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}>{coursePageObject?.lessonCard?.title1}</div>
    </div>
    <div style={{background:`${coursePageObject?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={coursePageObject?.lessonCard?.iconColor?.color}/></div> 


</div> <ImageFallFB  boxShadow={``}
                  src={coursePageObject?.lessonCard?.imageThumbnail?.src}
                  border={coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderType +" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={coursePageObject?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ coursePageObject?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
                   
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
    
   <h3 className="coursePageTitleFont"  style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding</h3>
   <p className="playerSidebarEllipsis coursePageSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding, he loves coding</p>
   </div>
</div>
</div>:coursePageObject?.lessonCard?.lessonCardTheme=="T2"?<div className="sidebarlessonInnerSection" >
    <div className="sidebarlessoImage">
   
  <ImageFallFB  boxShadow={``}
                  src={coursePageObject?.lessonCard?.imageThumbnail?.src}
                  border={coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.value+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderType +" "+coursePageObject?.lessonCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={coursePageObject?.lessonCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ coursePageObject?.lessonCard?.imageThumbnail?.borderRadius
                  }/>
                
</div>  
 <div className="sidebarlessonTitleSection" ><div style={{width:"100%"}}>
     <div className="sidebarCardLessonInner">
    <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px"}}>
    <Video size={26} color={coursePageObject?.lessonCard?.textColor?.color} />
    <div className="coursePageHeaderFont"  style={{fontSize:"16px",fontWeight:"800",margin:"0px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}>{coursePageObject?.lessonCard?.title1}</div>
    </div>
    <div style={{background:`${coursePageObject?.lessonCard?.iconBgColor?.color}`,width:"30px",height:"30px",borderRadius:"50%",
                  display:"flex",justifyContent:"center",alignItems:"center",   alignContent:"center",margin:"10px",cursor:"pointer"}} onClick={()=>{}} ><Info size={22}  color={coursePageObject?.lessonCard?.iconColor?.color}/></div> 


</div>
   <h3 className="coursePageTitleFont " style={{margin:"0px",paddingTop:"0px",marginTop:"-5px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding</h3>
   <p className="playerSidebarEllipsis coursePageSubTitleFont"style={{margin:"0px",paddingTop:"0px",fontSize:"11px",color:`${coursePageObject?.lessonCard?.textColor?.color}`}}> kaushal is a good coder , he loves coding, he loves coding</p>
   </div>
</div>
</div>:""}

</div>

<div >
     
     
</div>
    </div>
   </div>

    </div></div>


     <style>{`



     .playerSidebarEllipsis{
     position:relative;
     
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .sidebarLessonCardOuter{
    padding:10px;
    }
   
   .sidebarCardSectionInner{
    gap:10px;padding:5px; position:relative;
    display:flex;min-width:180px;
    justify-content:space-between;
    }.sidebarCardLessonInner{
    gap:10px; position:relative;margin-top:-20px;
    display:flex;min-width:180px;width:100%;
    justify-content:space-between;
    }

   
   
    .sidebarlessonCard{
    display:flex;
    justify-content:space-between;
    align-items:left;gap:10px;
    
    }
    .sidebarlessoImage{width:100px;}
    .sidebarlessonTitleSection,.sidebarlessonInnerSection{
    gap:10px;padding:5px; position:relative;
    display:flex;min-width:180px;width:100%;
    justify-content:left;
    align-items:left;}
.sidebarlessonInnerSectionThemeTwo{width:100%;}
.player-switchmutesmall {
    position: relative;padding:5px;padding-left:0px;
    display: inline-block;
    width: 77px;
    transform: scale(0.4);
    height: 25px;
    margin: 2px;
  }
  
  .player-switchmutesmall input {display:none;}
  
  .coursePagelfmutesmall {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color:${coursePageObject?.lessonCard?.toggleColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
    -webkit-transition: .4s;
    transition: .4s;
  }
  .coursePagelfmutesmall:before {
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    left: 0px;
    bottom: -4px;
    background: ${coursePageObject?.lessonCard?.toggleColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.03);;border:7px solid #f9f9f9;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .coursePagelfmutesmall {
     background: ${coursePageObject?.lessonCard?.toggleThumbColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
  }
  
  input:focus + .coursePagelfmutesmall {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .coursePagelfmutesmall:before {
    -webkit-transform: translateX(40px);
    -ms-transform: translateX(40px);
    transform: translateX(40px);
  }
  
  /* Rounded coursePagelfmutesmalls */
  .coursePagelfmutesmall.round {
    border-radius: 34px;
  }
  
  .coursePagelfmutesmall.round:before {
    border-radius: 50%;
  }
  
  .mutetitle{ position:relative; padding:5px;font-size:18px;top:-7px; font-weight:bold; }
  
  
.coursePage__wishlist,.coursePage__cart{background: ${coursePageObject?.lessonCardButtons?.btnColor?.color?coursePageObject?.lessonCardButtons?.btnColor?.color:"#222222"};
 
  border:${coursePageObject?.lessonCardButtons?.border?.borderWidth?.value}px ${coursePageObject?.lessonCardButtons?.border?.borderType} ${coursePageObject?.lessonCardButtons?.border?.borderColor?.color};
  
  
           border-top-left-radius:${coursePageObject?.lessonCardButtons?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${coursePageObject?.lessonCardButtons?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${coursePageObject?.lessonCardButtons?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${coursePageObject?.lessonCardButtons?.borderRadius?.bottomRight?.value+"px"};
 padding:5px;width:70px;height:30px;
 display:flex;justify-content:center;align-items:center;gap:2px;
  font-weight: 700;
  cursor: pointer;}


    `}</style>
    </>)
}
export default CourseContentCard;
